import type { CatalogEmbedConfig } from './CatalogEmbed.types';

// Scopes the lean international Add Gifts catalog to Cash Funds (weddings) + Charity and their descendants.
export const INTERNATIONAL_ADD_GIFTS_EMBED: CatalogEmbedConfig = {
  basePath: 'intl/add-gifts',
  defaultCategoryPublicPath: '/shop/catalog/cash-funds-wedding',
  allowedRootPublicPaths: ['/shop/catalog/cash-funds-wedding', '/shop/catalog/charity'],
  slugAliases: { 'cash-funds': 'cash-funds-wedding' },
};

const INTERNATIONAL_ADD_GIFTS_ROUTE_PATTERN = /\/edit\/registry\/intl\/add-gifts(?:\/|$)/;

// Route-derived (not provider-based) so it is visible to catalog state hooks mounted above the Add
// Gifts route. Public shop and US admin shop paths never match, so their behavior is unchanged.
export const resolveCatalogEmbedForPath = (pathname: string): CatalogEmbedConfig | null => {
  return INTERNATIONAL_ADD_GIFTS_ROUTE_PATTERN.test(pathname) ? INTERNATIONAL_ADD_GIFTS_EMBED : null;
};
